import { forwardRef, SelectHTMLAttributes } from 'react';
import InputError from './InputError';

interface Option {
  value: string;
  label: string;
}

interface LabeledSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  error?: string;
  options: Option[];
  placeholder?: string;
}

const LabeledSelect = forwardRef<HTMLSelectElement, LabeledSelectProps>(
  ({ label, error, options, placeholder, ...props }, ref) => {
    return (
      <fieldset className="form-control w-full">
        <legend className="label">
          <span className="fieldset-legend font-semibold text-sm">{label}</span>
        </legend>
        <select
          ref={ref}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          className="select select-lg bg-white w-full"
        >
          <option value="">{placeholder}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <InputError error={error} />
      </fieldset>
    );
  }
);

LabeledSelect.displayName = 'LabeledSelect';

export default LabeledSelect;
